import '@testing-library/jest-dom';
import { render, screen } from '@testing-library/react';

import { Attention } from './Attention';

describe('Attention', () => {
  it('should render (variant primary)', () => {
    render(<Attention>Attention message</Attention>);
    expect(screen.getByText('Attention message')).toBeInTheDocument();
  });
});
